import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

interface SearchInputProps {
  onSearch: (query: string) => void;
  placeholder?: string;
}

const SearchFilter: React.FC<SearchInputProps> = ({
  onSearch,
  placeholder = "Search across all report fields",
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);

    // Pass the value up to the parent component
    onSearch(value);
  };

  return (
    <div className="w-full relative h-[52px]">
      <FaSearch className="absolute text-gray-4 top-[16px] left-[18px] size={20} text-[20px]" />
      <input
        type="text"
        className="w-full bg-gray-1 border-[1.5px] border-gray-1 pl-[46px] pr-[18px] py-4 rounded-[50px] text-gray-7 font-normal text-base leading-5 outline-none focus:ring-1 focus:ring-black focus:border-transparent"
        placeholder={placeholder}
        value={inputValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchFilter;
